import { createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "tw-bg-home-gradient tw-absolute tw-w-full tw-h-3/4",
  style: {"z-index":"-1"}
}, null, -1)
const _hoisted_2 = {
  key: 1,
  class: "tw-bg-home-gradient tw-absolute tw-w-full tw-h-3/4",
  style: {"z-index":"-1"}
}
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.noTransition)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 0,
          "enter-active-class": "animate__animated animate__fadeIn",
          appear: ""
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2)),
    _createElementVNode("div", _mergeProps({ id: "public-layout" }, { ..._ctx.$attrs }, {
      class: `
      tw-w-screen
      tw-h-screen
      tw-flex 
      tw-p-6
      ${_ctx.justify === 'center' ? 'tw-justify-center' : _ctx.justify === 'end' ? 'tw-justify-end' : 'tw-justify-start'} 
      ${_ctx.align === 'center' ? 'tw-items-center' : _ctx.align === 'end' ? 'tw-items-end' : 'tw-items-start'}`
    }), [
      (!_ctx.noTransition)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            "enter-active-class": "animate__animated animate__fadeIn",
            appear: ""
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ]))
    ], 16)
  ], 64))
}